import React from "react";
import { IsRunningOverwolf } from "../utilityFunctions";

interface Props {
  imageBackground?: boolean;
  children: any;
}

const BackgroundColor: React.FC<Props> = ({ children, imageBackground }) => {
  return (
    <>
      <div
        className="w-full h-full -mt-2"
        style={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: IsRunningOverwolf() ? "calc(100vh)" : "calc(100vh)",
        }}
      >
        {children}
      </div>
    </>
  );
};

export default React.memo(BackgroundColor);
